export class WindRichtlinienab {
    windrichtung: number;
    beschreibung: string;
    windhaeufigkeit: number;
    idGebietskategorie: number;
    hg: number;

    get transportrichtung(): number {
        const w = this.windrichtung;
        return w > 170 ? (w - 180) : (w + 180);
    }
}

